import { createSelector } from 'reselect';
import localeUtils from 'utils/LanguageLocale';

// Dummy selector, is going to be changed later in OMNX-865.
const showShopYourStoreFilterAbTestSelector = createSelector(() => true);

const isShopYourStoreFilterEnabledSelector = createSelector(showShopYourStoreFilterAbTestSelector, showShopYourStoreFilterAbTest => {
    const country = localeUtils.getCurrentCountry();
    const killswitchName = 'shopYourStoreFilter' + country;
    const globalKillswitch = Sephora.configurationSettings[killswitchName]?.isEnabled === true;
    const isShopYourStoreFilterEnabled = globalKillswitch && showShopYourStoreFilterAbTest;

    return isShopYourStoreFilterEnabled;
});

export { isShopYourStoreFilterEnabledSelector };
